(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/select.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/select.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (components_select)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const _excluded = ["branding", "children", "className", "id", "inverted", "label", "name", "value", "v2"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  ;

  const Select = _ref => {
    let branding = _ref.branding,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      inverted = _ref.inverted,
      label = _ref.label,
      name = _ref.name,
      value = _ref.value,
      v2 = _ref.v2,
      props = _objectWithoutProperties(_ref, _excluded);
    const selectLabelClassNames = ['select-label'];
    const selectClassNames = ['select'];
    const labelClassNames = [];
    if (branding) {
      selectLabelClassNames.push("select-label-".concat(branding));
      selectClassNames.push("select-".concat(branding));
    } else if (inverted) {
      selectLabelClassNames.push('select-label-inverted');
      selectClassNames.push('select-inverted');
    } else {
      selectLabelClassNames.push('select-label-default');
      selectClassNames.push('select-default');
    }
    if (className) {
      selectClassNames.push(className);
    }
    if (v2) {
      selectClassNames.push('select-v2');
      labelClassNames.push('select-label-v2');
      if (inverted) {
        labelClassNames.push('select-label-v2-inverted');
      } else {
        labelClassNames.push('select-label-v2-default');
      }
    }
    const labelElement = label && React.createElement("label", {
      className: labelClassNames.join(' '),
      htmlFor: id
    }, label);
    return React.createElement(external_React_namespaceObject.Fragment, null, labelElement, React.createElement("div", {
      className: selectLabelClassNames.join(' ')
    }, React.createElement("select", _extends({
      className: selectClassNames.join(' '),
      id: id,
      name: name ? name : id
    }, props, {
      value: value
    }), children)));
  };
  Select.__docgenInfo = {
    "description": "Dropdown menus are to be utilized when user input required, and the possible input is limited to a discrete number of options.\nSelect displays a simple list of options, using the native menus of the users\u2019 OS / browser.",
    "methods": [],
    "displayName": "Select",
    "props": {
      "branding": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inverted": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "v2": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      }
    }
  };
  const components_select = Select;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Select = __webpack_exports__["default"];
})();

 })(window);